import styled from '@emotion/styled';
import { Flex, NakedButton, Icon, Box } from '@qga/roo-ui/components';

const HEADER_HIEGHT = '54px';

export const TitleBar = (props) => (
  <Flex
    minHeight={HEADER_HIEGHT}
    bg="white"
    borderBottom={1}
    borderColor="greys.alto"
    justifyContent="center"
    alignItems="center"
    px={HEADER_HIEGHT}
    {...props}
  />
);

const StyledButton = styled(NakedButton)`
  position: absolute;
  top: 0;
  left: 0;
  height: ${HEADER_HIEGHT};
  width: ${HEADER_HIEGHT};
`;

export const CloseButton = (props) => (
  <StyledButton position="absolute" {...props}>
    <Icon name="close" size={24} />
  </StyledButton>
);

export const BodyWrapper = (props) => <Box p={4} {...props} />;
